import * as React from 'react';
import { fromArrayToString } from '../../../utils/from-array-to-string.js';
import '@grandvisionhq/graphql';
import '@swc/helpers';
import { useAppointmentContext } from '../context/AppointmentContext.js';
import { useRoutingContext } from '../context/RoutingContext/context.js';

const timeSlotQueryParams = ()=>{
    const url = new URL(window.location.href);
    const { searchParams  } = url;
    const hasTimeSlotParams = searchParams.has('start') && searchParams.has('end');
    if (!hasTimeSlotParams) {
        return {};
    }
    return {
        start: searchParams.get('start'),
        end: searchParams.get('end')
    };
};
const useBookAppointmentTimeSlotWithUrlParam = ()=>{
    const [, { queryParams  }] = useRoutingContext();
    const [{ setTimeSlot  }, { timeSlot  }] = useAppointmentContext();
    React.useEffect(()=>{
        const { start: startFromUrl , end: endFromUrl  } = queryParams;
        const start = fromArrayToString(startFromUrl);
        const end = fromArrayToString(endFromUrl);
        const { start: newQueryParamStart , end: newQueryParamEnd  } = timeSlotQueryParams();
        // If newly updated query parameters do not match the previous routing context state
        // Do not update the state of timeSlot in the routingContext
        // Because we don't want to force a re-render on the page when change url params for start & end
        // This scenario occurs now in the 'who' step where users can choose a new timeslot
        if (newQueryParamStart !== start && newQueryParamEnd !== end) {
            return;
        }
        // Check if timeslot in ApointmentContext is not up to date with RoutingContext queryParams
        const hasDifferentTimeSlotFromUrl = !timeSlot || start !== `${timeSlot.from.getTime()}` || end !== `${timeSlot.until.getTime()}`;
        if (start && end && hasDifferentTimeSlotFromUrl) {
            setTimeSlot({
                from: new Date(Number(start)),
                until: new Date(Number(end))
            });
        }
    }, [
        queryParams,
        timeSlot,
        setTimeSlot
    ]);
};

export { useBookAppointmentTimeSlotWithUrlParam as default };
//# sourceMappingURL=use-book-appointment-time-slot-with-url-param.js.map
